import { useState, useCallback } from 'react';

type ToggleFn = () => void;

export function useToggle(startsEnabled = false): [boolean, ToggleFn] {
  const [toggleEnabled, setToggleEnabled] = useState(startsEnabled);
  const toggle = useCallback(() => {
    setToggleEnabled((prev) => !prev);
  }, []);

  return [toggleEnabled, toggle];
}
